<template>
  <v-card class="pa-4" flat>
    <v-alert
      v-model="alertShow"
      v-if="errorMessage"
      type="warning"
      variant="tonal"
      closable
      @click:close="closeMessage"
      class="mb-4"
    >
      {{ errorMessage }}
    </v-alert>
    <v-row justify="end">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          variant="underlined"
          label="Поиск"
          hide-details
        />

        <div class="d-flex justify-end mt-4 mb-6">
          <v-btn color="primary" @click="openEditDialog()">Добавить военкомат</v-btn>
        </div>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="offices"
      :search="search"
      :loading="loading"
      :items-per-page="-1"
    >
      <template #item.index="{ index }">
        {{ index + 1 }}
      </template>

      <template #item.address="{ item }">
        {{ item.address.standard }}
      </template>

      <template #item.actions="{ item }">
        <v-icon color="teal darken-1" class="me-2" @click="openEditDialog(item)">
          mdi-pencil
        </v-icon>

        <v-icon color="red darken-3" class="me-2" @click="openDeleteDialog(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="editDialog" max-width="800">
      <v-card>
        <v-card-title class="text-h6">
          {{ editedItem.id ? "Редактировать" : "Добавить" }} военкомат
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="editedItem.name"
                label="Название военкомата"
                hide-details="auto"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <address-form
                :token="dadataToken"
                v-model="editedItem.address"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="editDialog = false">Отмена</v-btn>
          <v-btn color="primary" @click="saveOffice">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="400px">
      <v-card>
        <v-card-title class="text-h6">Подтверждение удаления</v-card-title>
        <v-card-text>
          Удалить <strong>{{ selectedOffice?.name }}</strong>?
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">Отмена</v-btn>
          <v-btn color="red" @click="deleteOffice">Удалить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay v-model="processData" persistent class="align-center justify-center">
      <v-progress-circular indeterminate color="primary" size="64" />
    </v-overlay>
  </v-card>
</template>

<script>
import suggestion from "moodleDir/procollege/lib/vue/address/suggestion.js";
import addressForm from "moodleDir/procollege/lib/vue/address/form.vue";

export default {
  components: { addressForm },

  data() {
    return {
      search: "",
      loading: true,
      processData: false,

      headers: [
        { title: "#", value: "index", sortable: false },
        { title: "Название", value: "name" },
        { title: "Адрес", value: "address" },
        { title: "Действия", value: "actions", sortable: false },
      ],

      offices: [],
      editedItem: {},
      selectedOffice: null,
      dadataToken: null,

      editDialog: false,
      dialogDelete: false,

      errorMessage: "",
      alertShow: false,
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/dictionaries/militaryOffice/militaryGetDictionary"
        )
        .then((response) => {
          this.offices = response.data;
          this.loading = false;
        });

      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/index.php/core_procollege/helpers/Address/getDadataToken"
        )
        .then((response) => {
          this.dadataToken = response.data;
        });
    },

    openEditDialog(item = null) {
      if (item) {
        this.editedItem = {
          ...item,
          address: { value: item.address.standard, data: item.address },
        };
      } else {
        this.editedItem = {
          id: 0,
          name: "",
          address: suggestion,
        };
      }
      this.editDialog = true;
    },

    openDeleteDialog(item) {
      this.selectedOffice = item;
      this.dialogDelete = true;
    },

    closeMessage() {
      this.alertShow = false;
      this.errorMessage = "";
    },

    saveOffice() {
      if (!this.editedItem.name) {
        this.errorMessage = "Название обязательно";
        this.alertShow = true;
        return;
      }
      this.processData = true;

      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/dictionaries/militaryOffice/militaryAddItem",
          new URLSearchParams({
            item: JSON.stringify(this.editedItem),
          })
        )
        .then((response) => {
          this.offices = response.data;
        })
        .catch(() => {
          this.errorMessage = "Ошибка сохранения";
          this.alertShow = true;
        })
        .finally(() => {
          this.processData = false;
          this.editDialog = false;
        });
    },

    deleteOffice() {
      this.processData = true;

      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/dictionaries/militaryOffice/militaryDeleteItem",
          new URLSearchParams({ id: this.selectedOffice.id })
        )
        .then((response) => {
          this.offices = response.data;
        })
        .finally(() => {
          this.processData = false;
          this.dialogDelete = false;
        });
    },
  },
};
</script>
